import { memo, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorScreen as BaseErrorScreen } from '@/js/libs/error-boundary';

interface ErrorScreenProps {
  className?: string;
  error: Error;
  withReload?: boolean;
}

export const ErrorScreen: FC<ErrorScreenProps> = memo(function ErrorScreen({ className, error, withReload }) {
  const [t] = useTranslation(['backend', 'common', 'components']);

  return (
    <BaseErrorScreen
      className={className}
      error={error}
      title={t('components:APP_ERROR')}
      reloadLabel={withReload ? t('common:RELOAD') : undefined}
    />
  );
});

/*
  The application-wide boundary replaces the whole UI, so its screen is the only one that needs
  a way out. Nested boundaries stay dismissable by the modal or form around them.
 */
export const RootErrorScreen: FC<ErrorScreenProps> = memo(function RootErrorScreen(props) {
  return <ErrorScreen {...props} withReload />;
});
